module.exports = __webpack_public_path__ + "img/vertical.ed3d5847.jpg";